export const ROUTES_INITIAL_STATE: { allSessionRoutes: string[] } = {
  allSessionRoutes: [],
};
